import { createContext, ReactElement, useEffect, useState,useMemo} from 'react';
import { useLocation } from 'react-router';

const ContemporaryContext = createContext<{ setData: (data: Object) => void; prevStoredData: any } | null>(null);

export const ContemporaryProvider = ({ children }: { children: ReactElement }) => {
  const [prevStoredData, setPrevStoredData] = useState<any>({});
  const { pathname } = useLocation();
  useEffect(() => {
    const filteredData = Object.keys(prevStoredData).reduce((acc: any, key: string) => {
      if (key === pathname || prevStoredData[key]?.gotoUrl === pathname) {
        acc[key] = prevStoredData[key];
      }
      return acc;
    }, {});
    setPrevStoredData(filteredData);
  }, [pathname]);

  const setData = (data: Object) => {
    setPrevStoredData((prev: any) => ({
      ...prev,
      ...data
    }));
  };

  const value = useMemo(
    () => ({ prevStoredData, setData }),
    [prevStoredData] 
  );


  return <ContemporaryContext.Provider value={value}>{children}</ContemporaryContext.Provider>;
};
export default ContemporaryContext;
